import { Mail, type LucideIcon } from "lucide-react";

import { routes, type RouteHref } from "@/app/common/functions/routes/routes";

/** A section of the site: plain text in the bar and the phone menu. */
type Section = { label: string; href: RouteHref; emphasized?: false };

/** The bar's one call to action, drawn as a button with its mark, set apart. */
type CallToAction = {
  label: string;
  href: RouteHref;
  icon: LucideIcon;
  emphasized: true;
};

type NavigationItem = Section | CallToAction;

export const isCallToAction = (item: NavigationItem): item is CallToAction =>
  item.emphasized === true;

export const primaryNavigation: readonly NavigationItem[] = [
  { label: "About", href: routes.about },
  { label: "Capabilities", href: routes.capabilities.index },
  { label: "Industries", href: routes.industries.index },
  { label: "Blog", href: routes.blog.index },
  {
    label: "Contact",
    href: routes.contact,
    icon: Mail,
    emphasized: true,
  },
];
